export default __webpack_public_path__ + "static/media/logo-white.47208429.png";